import React from 'react';

import ButtonBase from './button-base';
import { BaseButtonProps } from './types';

/**
 * Returns an instance of a Button.
 *
 * @param btnText - Contents of the button.
 * @param className - Class name(s) to apply.
 * @param disabled - If true, sets `disabled` property on the button.
 * @param id - The value to set for the `id` property.
 * @param name - The value to set for the `name` property.
 * @param onClick - The callback handler for the click event.
 * @param type - Type property. Must be `button`, `reset`, or `submit`.
 * @param value - Value to set on the button.
 * @param props - Customization options passed to base button.
 * @returns React.ReactNode.
 *
 * @example
 *
 * ```typescriptreact
 * <Button
 *   btnText="Example Button"
 *   className="cta primary large"
 *   disabled={false}
 *   type="submit"
 * />
 * ```
 */
export function Button({ btnText, className, disabled, id, name, onClick, type, value, ...props }: BaseButtonProps) {
  return (
    <ButtonBase
      className={className}
      disabled={disabled}
      id={id}
      name={name}
      onClick={onClick}
      type={type}
      value={value}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {btnText}
    </ButtonBase>
  );
}

export { BackButton } from './back-button';
export { CalendarNavigationButton } from './calendar-navigation-button';
export { DoneButton } from './done-button';
export { GiveButton } from './GiveButton';
export { SocialButton } from './social-button';
export { TextButton } from './text-button';
